export default __webpack_public_path__ + "static/media/Delete.6c8db36f.svg";